import {
  HIDE_CAMPAIGN_ADVERTISING_ACCOUNTS_LOADER,
  SET_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE,
  SET_CAMPAIGN_ADVERTISING_ACCOUNTS_LIST,
  SHOW_CAMPAIGN_ADVERTISING_ACCOUNTS_LOADER,
  SET_CAMPAIGN_CUSTOMER_DATA
} from "./actionTypes";
import { INITIAL_DATA_PARAMS } from "../../../constants/store";

const INIT_STATE = {
  data: INITIAL_DATA_PARAMS,
  customer_data: {},
  profile: null,
  loading: false,
  error: null
}

const CampaignAdvertisingAccountList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CAMPAIGN_ADVERTISING_ACCOUNTS_LIST:
      return {
        ...state,
        data: action.payload
      }
    case SET_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE:
      return {
        ...state,
        profile: action.payload
      };
    case SHOW_CAMPAIGN_ADVERTISING_ACCOUNTS_LOADER:
      return {
        ...state,
        loading: true
      }
    case HIDE_CAMPAIGN_ADVERTISING_ACCOUNTS_LOADER:
      return {
        ...state,
        loading: false
      }
    case SET_CAMPAIGN_CUSTOMER_DATA:
      return {
        ...state,
        customer_data: action.payload,
      }
    default:
      return state
  }
}

export default CampaignAdvertisingAccountList;
